export default __webpack_public_path__ + "static/media/close.838a5644.svg";